import { render, staticRenderFns } from "./RiasecCongratulation.vue?vue&type=template&id=e61f74c2&scoped=true"
import script from "./RiasecCongratulation.vue?vue&type=script&lang=js"
export * from "./RiasecCongratulation.vue?vue&type=script&lang=js"
import style0 from "./RiasecCongratulation.vue?vue&type=style&index=0&id=e61f74c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61f74c2",
  null
  
)

export default component.exports